import axios from "axios";
//const apibaseurl='https://dev-mmm-api.trigma.ai/';
//const apibaseurl='http://localhost:5251/';
//const apibaseurl='https://nitbiapi.azurewebsites.net/';//
//const apibaseurl='http://nitbiapi.niticket.in/';//
const apibaseurl='https://biapi.paygetticket.com/';//
//const apibaseurl='http://localhost:5198/api/usermanagement/';
//http://localhost:5198/api/usermanagement
const macaddress= '10.18.2.121';
const webapibase = axios.create({
    baseURL: apibaseurl,
    params: {
        auth_key:'4549A1EA-9C0D-43A1-98E7-F2B5D13095DC',
        mac_address:macaddress,
        uid:1,
        appid:4,
        token:'test23062022'
      }
});
export default webapibase;